var _path, _g, _path2, _path3, _path4, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_640_2750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 16,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.957H17.1838V21.0566H2V13.957Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_640_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.592 15.457C6.813 15.457 3.5 15.814 3.5 17.519C3.5 18.871 5.55 19.557 9.592 19.557C13.634 19.557 15.684 18.864 15.684 17.499C15.684 16.144 13.634 15.457 9.592 15.457ZM9.592 21.057C7.516 21.057 2 21.057 2 17.519C2 13.957 7.714 13.957 9.592 13.957C12.851 13.957 17.184 14.324 17.184 17.499C17.184 21.057 11.47 21.057 9.592 21.057Z",
    fill: "#515151"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59205 3.5C7.58705 3.5 5.95605 5.131 5.95605 7.135C5.95605 9.139 7.58705 10.77 9.59205 10.77H9.62305C10.5871 10.766 11.4951 10.387 12.1761 9.7C12.8581 9.015 13.2311 8.104 13.2271 7.138C13.2271 5.131 11.5961 3.5 9.59205 3.5ZM9.59205 12.27C6.76005 12.27 4.45605 9.966 4.45605 7.135C4.45605 4.304 6.76005 2 9.59205 2C12.4231 2 14.7271 4.304 14.7271 7.135C14.7331 8.499 14.2041 9.787 13.2401 10.757C12.2781 11.728 10.9931 12.265 9.62605 12.27H9.59205Z",
    fill: "#515151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4827 11.1318C16.1147 11.1318 15.7937 10.8608 15.7407 10.4858C15.6837 10.0758 15.9687 9.69577 16.3787 9.63877C17.6267 9.46377 18.5687 8.38077 18.5707 7.11877C18.5707 5.86477 17.6727 4.80677 16.4377 4.60477C16.0287 4.53677 15.7517 4.15177 15.8187 3.74277C15.8857 3.33377 16.2727 3.05877 16.6797 3.12377C18.6447 3.44577 20.0707 5.12677 20.0707 7.11977C20.0667 9.12477 18.5697 10.8468 16.5877 11.1248C16.5527 11.1298 16.5177 11.1318 16.4827 11.1318Z",
    fill: "#515151"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_640_2750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 13,
    width: 5,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8457 13.4834H21.9795V18.4609H17.8457V13.4834Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_640_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.896 18.4609C19.593 18.4609 19.308 18.2759 19.195 17.9769C19.048 17.5899 19.243 17.1559 19.63 17.0099C20.48 16.6879 20.48 16.2949 20.48 16.1269C20.48 15.5599 19.809 15.1719 18.486 14.9749C18.076 14.9129 17.793 14.5309 17.854 14.1219C17.916 13.7119 18.305 13.4369 18.707 13.4899C21.413 13.8949 21.98 15.1479 21.98 16.1269C21.98 16.8559 21.665 17.8429 20.162 18.4119C20.075 18.4449 19.985 18.4609 19.896 18.4609Z",
    fill: "#515151"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisits);
export default __webpack_public_path__ + "static/media/visits.9e22bb419db27b91f68a035396d5fc9e.svg";
export { ForwardRef as ReactComponent };